<template>
  <div
    class="affiliate"
    :class="{ 'is-invalid': !affiliate.isValid }"
    v-if="affiliate.showMessage && affiliate.message"
  >
    <div
      class="message"
      v-html="affiliate.message"
      data-testid="affiliate-message"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AffiliateBlurb",
  computed: {
    ...mapState(["affiliate"]),
  },
};
</script>

<style lang="scss" scoped>
.affiliate {
  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 1.6rem;
  color: #224b81;
  background-color: #d6ecf9;
  border: 1px solid #00a2e1;
  border-radius: $border-radius-small;
  padding: $spacing-small;
  margin: 0 0 $spacing-medium 0;

  &.is-invalid {
    background-color: lighten($error, 60%);
    border-color: $error;
  }

  @include media("<medium") {
    margin-top: $spacing-small;
  }
}
</style>
